// Comprehensive list of major global stock exchanges, sorted alphabetically by name
const STOCK_EXCHANGES = [
  { code: "ASX", name: "Australian Securities Exchange", country: "Australia" },
  { code: "B3", name: "B3 (Brasil Bolsa Balcao)", country: "Brazil" },
  { code: "BER", name: "Berlin Stock Exchange", country: "Germany" },
  { code: "BIT", name: "Borsa Italiana", country: "Italy" },
  { code: "BME", name: "Bolsa de Madrid", country: "Spain" },
  { code: "BSE", name: "Bombay Stock Exchange", country: "India" },
  { code: "BIST", name: "Borsa Istanbul", country: "Turkey" },
  { code: "BVB", name: "Bucharest Stock Exchange", country: "Romania" },
  { code: "BVMF", name: "BM&F Bovespa", country: "Brazil" },
  { code: "CSE_COLOMBO", name: "Colombo Stock Exchange", country: "Sri Lanka" },
  { code: "CSE_CASABLANCA", name: "Casablanca Stock Exchange", country: "Morocco" },
  { code: "DSE", name: "Dhaka Stock Exchange", country: "Bangladesh" },
  { code: "DFMGI", name: "Dubai Financial Market", country: "UAE" },
  { code: "EGX", name: "Egyptian Exchange", country: "Egypt" },
  { code: "EURONEXT", name: "Euronext", country: "Europe" },
  { code: "FRA", name: "Frankfurt Stock Exchange", country: "Germany" },
  { code: "GSE", name: "Ghana Stock Exchange", country: "Ghana" },
  { code: "HKEX", name: "Hong Kong Exchanges", country: "Hong Kong" },
  { code: "IDX", name: "Indonesia Stock Exchange", country: "Indonesia" },
  { code: "ISE", name: "Irish Stock Exchange", country: "Ireland" },
  { code: "JSE", name: "Johannesburg Stock Exchange", country: "South Africa" },
  { code: "KLSE", name: "Bursa Malaysia", country: "Malaysia" },
  { code: "KOSPI", name: "Korea Exchange (KOSPI)", country: "South Korea" },
  { code: "KSE", name: "Karachi Stock Exchange", country: "Pakistan" },
  { code: "LSE", name: "London Stock Exchange", country: "United Kingdom" },
  { code: "MOEX", name: "Moscow Exchange", country: "Russia" },
  { code: "NASDAQ", name: "NASDAQ", country: "USA" },
  { code: "NSE_INDIA", name: "National Stock Exchange of India", country: "India" },
  { code: "NSE_KENYA", name: "Nairobi Securities Exchange", country: "Kenya" },
  { code: "NSE_NIGERIA", name: "Nigerian Exchange Group (NGX)", country: "Nigeria" },
  { code: "NZX", name: "New Zealand Exchange", country: "New Zealand" },
  { code: "NYSE", name: "New York Stock Exchange", country: "USA" },
  { code: "OMX_NORDIC", name: "Nasdaq Nordic (OMX)", country: "Nordic Region" },
  { code: "OSE", name: "Oslo Stock Exchange", country: "Norway" },
  { code: "PSE", name: "Philippine Stock Exchange", country: "Philippines" },
  { code: "QSE", name: "Qatar Stock Exchange", country: "Qatar" },
  { code: "SAU", name: "Saudi Exchange (Tadawul)", country: "Saudi Arabia" },
  { code: "SET", name: "Stock Exchange of Thailand", country: "Thailand" },
  { code: "SGX", name: "Singapore Exchange", country: "Singapore" },
  { code: "SIX", name: "SIX Swiss Exchange", country: "Switzerland" },
  { code: "SSE", name: "Shanghai Stock Exchange", country: "China" },
  { code: "SZSE", name: "Shenzhen Stock Exchange", country: "China" },
  { code: "TASE", name: "Tel Aviv Stock Exchange", country: "Israel" },
  { code: "TSE", name: "Tokyo Stock Exchange", country: "Japan" },
  { code: "TSX", name: "Toronto Stock Exchange", country: "Canada" },
  { code: "TWSE", name: "Taiwan Stock Exchange", country: "Taiwan" },
  { code: "VSE", name: "Vienna Stock Exchange", country: "Austria" },
  { code: "WSE", name: "Warsaw Stock Exchange", country: "Poland" },
  { code: "ZSE", name: "Zimbabwe Stock Exchange", country: "Zimbabwe" },
  { code: "OTHER", name: "Other Exchange", country: "" },
];

export default STOCK_EXCHANGES;
